import { QuoQuestLevelStage } from "../types/quest";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import QuoQuestLevelStageCard from "./QuoQuestLevelStageCard";
import { Controller } from "swiper";
import SwiperClass from "swiper/types/swiper-class";
import QuoQuestLevelStageDateRange from "./QuoQuestLevelStageDateRange";
import QuoQuestLevelChart from "./QuoQuestLevelChart";

interface QuoQuestLevelSliderProps {
  level: number;
  stages: QuoQuestLevelStage[];
  currentSlide: number;
  onSwipe: (activeSlideIndex: number) => void;
}

const QuoQuestLevelSlider = ({
  level,
  stages,
  currentSlide,
  onSwipe
}: QuoQuestLevelSliderProps) => {
  const [firstSwiper, setFirstSwiper] = useState<SwiperClass>();
  const [secondSwiper, setSecondSwiper] = useState<SwiperClass>();

  // I have to do this otherwise the initialSlide={currentSlide} does nothing
  useEffect(() => {
    if (firstSwiper && secondSwiper) {
      // "equivalent" to controller={{ control: secondSwiper }}
      firstSwiper.slideTo(currentSlide);
      // "equivalent" to controller={{ control: firstSwiper }}
      secondSwiper.slideTo(currentSlide);
    }
  }, [firstSwiper, secondSwiper, currentSlide]);

  return (
    <>
      <Swiper
        initialSlide={currentSlide}
        modules={[Controller]}
        slidesPerView={1}
        centeredSlides={true}
        spaceBetween={0}
        className="w-full grow my-4"
        onSwiper={swiper => {
          setFirstSwiper(swiper);
        }}
        onSlideChange={() => {
          onSwipe(firstSwiper?.activeIndex ?? currentSlide);
        }}
      >
        {stages.map(stage => (
          <SwiperSlide key={stage.stageId} className="flex flex-col">
            <div className="w-full grow flex items-center justify-center">
              <QuoQuestLevelChart
                graph={stage.graph}
                hasCleared={stage.hasCleared}
                marketDateFrom={stage.marketDateFrom}
                marketDateTo={stage.marketDateTo}
                level={level}
              />
            </div>
            <QuoQuestLevelStageDateRange
              dateFrom={stage.marketDateFrom}
              dateTo={stage.marketDateTo}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        initialSlide={currentSlide}
        modules={[Controller]}
        slidesPerView={1.15}
        centeredSlides={true}
        spaceBetween={0}
        className="w-full"
        onSwiper={swiper => {
          setSecondSwiper(swiper);
        }}
        onSlideChange={() => {
          onSwipe(secondSwiper?.activeIndex ?? currentSlide);
        }}
      >
        {stages.map((stage, index) => (
          <SwiperSlide key={stage.stageId} className="flex flex-col">
            <QuoQuestLevelStageCard
              level={level}
              stage={stage}
              stageIndex={index}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default QuoQuestLevelSlider;
